import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { formatEmoji } from '../../utils/fillDynamicText';

const Button = styled.button`
    span {
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-events: none;
        font-family: Averta;
        text-transform: ${props => (props.textUppercase ? 'uppercase' : 'none')};
    }

    .emoji {
        font-size: 40px;
        line-height: 1.25;
    }
`;

const AnswerButton = props => (
    <Button
        onClick={props.onClick}
        data-answer={props.text}
        textUppercase={props.textUppercase}
    >
        <span
            data-answer-text={props.text}
            dangerouslySetInnerHTML={{
                __html: formatEmoji(props.text)
            }}
        />
    </Button>
);

AnswerButton.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    textUppercase: PropTypes.bool
};

export default AnswerButton;
